import WithFormEvent from '../../components/WithFormEvent'
import EmailDirect from '../../views/Pages/EmailDirect/EmailDirect';
import { ajaxPost, loginInfo, history, connection } from '../../global';

const EmailDirectCtrl = WithFormEvent(EmailDirect, {
    
});

export default EmailDirectCtrl;


// WEBPACK FOOTER //
// ./src/containers/Master/EmailDirect.js